import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/gallery-minimalist/components/GalleryMinimalistViewer.tsx");
